export const SHAKEDEX_URL = process.env.SHAKEDEX_URL || 'https://api.shakedex.com';
